import { CameraOrientations } from '@reducers/camera/defaults/woodConnection';
import Axis from '@scene/axis';
import WoodConnectionType1 from '../../../assets/images/WoodConnectionType1.png';
import WoodConnectionType2 from '../../../assets/images/WoodConnectionType2.png';
import WoodConnectionType3 from '../../../assets/images/WoodConnectionType3.png';
import WoodPanelType1 from '../../../assets/images/WoodPanelType1.png';
import WoodPanelType2 from '../../../assets/images/WoodPanelType2.png';
import WoodPanelType3 from '../../../assets/images/WoodPanelType3.png';

export const woodConnectionTypes = [
  {
    id: 0,
    icon: WoodConnectionType1,
    woodPanel: {
      T: 45,
      L: 145,
      thicknessE1: 45,
      image: WoodPanelType1
    },
    tooltip: "TT262", //APP_TOOLTIPS.TOOLTIP_WOOD_CONFIG_1.Content
    perspectiveCamera: CameraOrientations.CONFIG_1.perspectiveCamera,
    orientation: {
      orientation3D: Axis.types.Z_TOP,
    }
  },
  {
    id: 1,
    icon: WoodConnectionType2,
    woodPanel: {
      T: 45,
      L: 145,
      thicknessE1: 45,
      thicknessE2: 45,
      image: WoodPanelType2
    },
    tooltip: "TT263", //APP_TOOLTIPS.TOOLTIP_WOOD_CONFIG_2.Content
    perspectiveCamera: CameraOrientations.CONFIG_2.perspectiveCamera,
    orientation: {
      orientation3D: Axis.types.Z_TOP_X_FORWARD,
    }
  },
  {
    id: 2,
    icon: WoodConnectionType3,
    woodPanel: {
      T: 45,
      L: 145,
      thicknessE1: 45,
      thicknessE2: 45,
      image: WoodPanelType3
    },
    tooltip: "TT264", //APP_TOOLTIPS.TOOLTIP_WOOD_CONFIG_3.Content
    perspectiveCamera: CameraOrientations.CONFIG_3.perspectiveCamera,
    orientation: {
      orientation3D: Axis.types.Z_TOP,
    }
  }
];



// WEBPACK FOOTER //
// ./src/reducers/selectors/application/initialState-wood-connection.js